<div class="rule-summary border">
	<div class="rule-summary-top">
		<h3
			class="heading-3"
			*ngIf="!rule; else clickedRule"
		>
			{{ setHeaderText() }}
		</h3>

		<ng-template #clickedRule>
			<h3 class="heading-3">{{ rule?.name || ("no rule" | i18next: { format: "capitalize" }) }}</h3>
		</ng-template>

		<div style="display: flex; gap: 1em">
			<app-action-button
				[disabled]="!rule || !rule.id"
				title="edit"
				(buttonClicked)="editButtonClick()"
			></app-action-button>

			<app-action-button
				[disabled]="!rule || !rule.id"
				title="close"
				(buttonClicked)="closeButtonClick()"
			></app-action-button>
		</div>
	</div>

	<div class="rule-summary-bottom">
		<p
			id="no-rule"
			class="bold"
			*ngIf="!rule || !rule?.id"
		>
			{{ "only one rule can be viewed at a time" | i18next }}
		</p>
		<ngx-skeleton-loader
			count="5"
			*ngIf="!showTripDetails && rule && rule.id"
		></ngx-skeleton-loader>
		<!-- not doing an if else ng template technique because all we need is the visibility of the skeleton, the rule summary is too pushed down to bother with that logic -->
		<ng-container *ngIf="rule && rule.id">
			<p>
				<b>{{ "excluded zones" | i18next: { format: "capitalize" } }}:</b>
				{{ excludedZones$ | async }}
			</p>

			<div class="duties">
				<div class="start">
					<p class="bold">{{ "duty start" | i18next: { format: "capitalize" } }}</p>
					<app-trip-start-end
						[tripStartOrEnd]="rule?.tripStart"
						[tripZones]="startTripZones$ | async"
					></app-trip-start-end>
				</div>
				<div class="end">
					<p class="bold">{{ "duty end" | i18next: { format: "capitalize" } }}</p>
					<app-trip-start-end
						[tripStartOrEnd]="rule?.tripEnd"
						[tripZones]="endTripZones$ | async"
					></app-trip-start-end>
				</div>
			</div>
		</ng-container>
	</div>
</div>
